<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'
import {useRouter} from "vue-router"

const props = defineProps({
    item: Object,
    value: String
})

// Pinia Store
const userStore = useUserStore()

// Router Instance
const router = useRouter()

const user = computed(() => {
    return userStore.user
})

const onClick = () => {
    router.push({
        name: 'form',
        params: {
            component: 'm_basket_orderitems',
            id: props.item.id
        }
    })
}
</script>

<template>
    <a v-if="user?.administrator" href @click.prevent="onClick">{{ value }}</a>
    <span v-else>{{ value }}</span>
</template>